'use client';

/* eslint-disable react/no-array-index-key */
/* eslint-disable no-inline-styles/no-inline-styles */
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React, { useState } from 'react';

import Button from 'molecules/Button';
import styles from 'molecules/Quiz/quiz.module.scss';

import type { FC } from 'react';

type QuizProps = {
  title?: string;
  questions?: {
    question?: string;
    answer?: string;
    description?: string;
    questionType?: 'True/False' | 'Multiple Choice';
    options?: { value: { data: { options: string } } };
    userAnswer?: string;
  }[];
};

const Quiz: FC<QuizProps> = ({ title, questions = [] }) => {
  const [results, setResults] = useState<any[]>([]);

  const checkAnswer = (qs: QuizProps['questions']) => {
    const result: any[] = [];
    qs?.forEach(({ answer, userAnswer, description }, index) => {
      if (userAnswer === answer) {
        result.push(
          <p key={`correct-${index}`}>
            {index + 1}. Correct! The answer is <b>{answer}</b>. {description}
          </p>,
        );
      } else {
        result.push(
          <p key={`incorrect-${index}`}>
            {index + 1}. Incorrect - The answer was <b>{answer}</b>. {description}
          </p>,
        );
      }
    });

    return result;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    if (questions && questions[index]) {
      questions[index].userAnswer = event.target.value;
    }
  };

  return (
    <div className={styles.main}>
      <h4 className={styles.heading}>{title}</h4>
      {questions.map(({ question, questionType, options }, index) => (
        <div className={styles.questions} key={`questionDiv-${index}`}>
          {index + 1}. {question}
          <RadioGroup key={`item-${index}`} aria-label={`question-${index}`} name={`radio-buttons-group-${index}`}>
            {questionType === 'Multiple Choice'
              ? JSON.parse(options?.value?.data?.options || '[]').map((option: string, optionIndex: number) => (
                  <FormControlLabel
                    key={`option-${index}-${optionIndex}`}
                    value={option}
                    control={<Radio />}
                    label={<span style={{ fontSize: '18px', fontFamily: 'acumin-pro' }}>{option}</span>}
                    onChange={e => handleChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                  />
                ))
              : ['True', 'False'].map((option, optionIndex) => (
                  <FormControlLabel
                    key={`option-${index}-${optionIndex}`}
                    className={styles.radio}
                    value={option}
                    control={<Radio />}
                    label={<span style={{ fontSize: '18px', fontFamily: 'acumin-pro' }}>{option}</span>}
                    onChange={e => handleChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                  />
                ))}
          </RadioGroup>
        </div>
      ))}
      <Button
        className={styles.btn}
        id="checkAnswerBtn"
        color="gray"
        onClick={() => setResults(checkAnswer(questions))}
      >
        Check Answers
      </Button>
      {results.length > 0 && <h4 className={styles.heading}>Answers</h4>}
      <div>
        {results.map((result, index) => (
          <p key={`result-${index}`} className={styles.result}>
            {result}
          </p>
        ))}
      </div>
    </div>
  );
};

export default Quiz;
